export default "__VITE_ASSET__BzcAYqs5__"